export const TOPBAR_NODE_ID = 'pageLayoutTopbar';
